// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-items[data-v-7f38364e]{width:58%}@media screen and (max-width:960px){.menu-items[data-v-7f38364e]{width:65%}}.variant-name[data-v-7f38364e]{align-items:end;display:inline-flex;line-height:14px;max-width:45%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
